<template>
  <router-link v-if="news" :to="{ name: 'NewsSingle', params: { id: news.id }}" class="news-overview">
    <div class="grid grid--s20 grid--middle">
      <div class="grid__item">

        <div class="news-overview__image-wrapper" :class="{
        	'news-overview__image-wrapper--fallback' : !imageStyles,
        }">
          <div class="news-overview__image" v-bind:style="imageStyles"></div>

					<div v-if="news.postType == 'video'" class="grunticon grunticon--play news-overview__image-action"></div>
        </div>

      </div>
      <div class="grid__item">

        <div class="news-overview__meta-wrapper">
          <div v-if="isNew" class="news-overview__new-badge">
            <span class="grunticon grunticon--badge--new"></span>
          </div>

          <div v-if="news.date" class="news-overview__meta">
          	<div class="grid grid--g8 grid--s0 grid--auto grid--middle">
          		<div v-if="news.date" class="grid__item">

		            <span class="news-overview__date">{{news.date | formatDate}}</span>

          		</div>
          		<div v-if="news.category" class="grid__item">

          			<span>•</span>

          		</div>
          		<div v-if="news.category" class="grid__item">

          	    <span class="news-overview__category">{{$store.state.app.categories[news.category]}}</span>

          		</div>
          	</div>
          </div>


					<div v-if="news.title" class="news-overview__title" v-html="news.title"></div>

          <div v-if="news.summary && showSummary" class="news-overview__summary" v-html="news.summary"></div>

        </div>
      </div>

    </div>
  </router-link>
</template>

<script>

export default {
  name: "NewsOverview",
  components: {
  },
  data() {
    return {
    };
  },
  props: {
    news: {
      type: Object,
      default: null
    },
    showSummary: {
      type: Boolean,
      default: true
    },
    isNew: {
      type: Boolean,
      default: false
    },
    imageClickable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    inputListeners: function() {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function(event) {
            vm.$emit("input", event.target.value);
          }
        }
      );
    },
    imageStyles: function() {
    	return this.news && this.news.imageLarge && this.news.imageLarge.link ? { backgroundImage: `url('${this.news.imageLarge.link}')` } : null;
    },
  },
  mounted: function() {},
  methods: {
    onClick(evt)
    {
      if (this.news && this.news.content[0].type == "link")
      {
        this.trackEvent([
          "news-link-clicked",
          this.news.content[0].url,
          this.$root.$data.user ? this.$root.$data.user.trackName : null,
          0,
          false
        ]);
      }
    }
  }
};
</script>

<style lang="scss">
@import "src/scss/toolkit";

$c: ".news-overview";
#{$c} {
  position: relative;

  &__image-wrapper {
    position: relative;
    display: block;
    text-align: center;
    border-radius: 4px;
    overflow: hidden;

    &--fallback
    {
    	@include extend(bg-fill);
    	background-image: url('../../assets/img/news/fallback.jpg');
    }

    > *,
    &:before {
      display: inline-block;
      vertical-align: middle;
    }

    &:before {
      position: relative;
      z-index: 1;
      content: "";
      width: 0;
      padding-top: 100% * (272/376);
    }
  }

  &__image {
    display: block;
    @include extend(bg-fill);
    @include extend(absolute-fill);
    background-position: center center;
  }

  &__image-action
  {
  	width: rem(60);
  	height: rem(60);
  }

  &__new-badge {
    margin-bottom: rem(16);
  }

  &__meta {
  	color: palette('light-grey');
  	font-size: rem(14);
    margin-bottom: rem(4);
  }

  &__title {
    @include extend(h5);
    @include extend(heading--black);

    &:not(:last-child) { margin-bottom: rem(8); }
  }

  &__summary
  {
  	color: palette('grey');
  	font-size: rem(16);
  	line-height: (26/16);
  }

  &__category
  {
    display: inline-block;
    // color: palette(link);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/NewsOverview.vue